import React from 'react';
import bgLeft from 'assets/images/bg_left.png';
import bgTop from 'assets/images/bg_top.png';
import bgStt from 'assets/images/bg_stt.png';
import bgLine from 'assets/images/bg_line.png';
import bgImg from 'assets/images/bg_img.png';
import { heroAvatar } from './constants';

const TopVoteList = ({ leftRankingList, selectedRankIndex, onSelectRank, hideCountryOnCard }) => {
  return (
    <aside
      className="order-2 md:order-1 rounded-[20px] border-[2px] border-[#11833c] p-3 md:p-4 bg-no-repeat bg-center bg-cover"
      style={{ backgroundImage: `url(${bgLeft})` }}
    >
      <div
        className="mx-auto mb-3 flex h-[52px] w-[286px] items-center justify-center bg-no-repeat bg-center bg-contain md:h-[64px] md:w-[352px]"
        style={{ backgroundImage: `url(${bgTop})` }}
      />

      <div className="scrollbar-hide max-h-[472px] space-y-2 overflow-y-auto pr-1">
        {leftRankingList.map((item, idx) => (
          <div
            key={`${item.name}-${idx}`}
            className="grid w-full grid-cols-[42px_minmax(0,1fr)] items-center gap-[8px]"
          >
            <div
              className="flex h-[52px] w-[46px] shrink-0 items-center justify-center bg-no-repeat bg-center bg-contain"
              style={{ backgroundImage: `url(${bgStt})` }}
            >
              <div className="flex h-[44px] w-[38px] items-center justify-center text-[30px] font-black leading-none text-white">
                {idx + 1}
              </div>
            </div>

            <button
              type="button"
              onClick={() => onSelectRank(item, idx)}
              className={`grid h-[52px] w-full grid-cols-[minmax(0,1fr)_30px_44px] items-center rounded-[14px] border-none appearance-none bg-no-repeat bg-center px-[10px] text-white shadow-none outline-none ring-0 transition-all focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 ${
                idx === selectedRankIndex ? 'brightness-120' : ''
              }`}
              style={{
                background: `url(${bgLine}) no-repeat center / 100% 100%`,
                boxShadow: 'none',
                border: 'none',
                outline: 'none',
                WebkitAppearance: 'none',
                MozAppearance: 'none',
                appearance: 'none'
              }}
            >
              <div className="min-w-0 truncate pl-1 pr-2 text-left text-[18px] font-extrabold leading-none max-[980px]:text-[18px] md:pl-2 md:text-[17px]">
                {item.name}
              </div>
              {hideCountryOnCard ? (
                <div className="flex h-[34px] w-[34px] shrink-0 items-center justify-center">
                  <div className="h-[22px] w-[34px] overflow-hidden rounded-[2px]">
                    <img
                      src={item.avatar || heroAvatar}
                      alt={item.name}
                      className="h-full w-full object-cover object-center"
                    />
                  </div>
                </div>
              ) : (
                <div
                  className="relative h-[34px] w-[34px] shrink-0 bg-no-repeat bg-center bg-contain"
                  style={{ backgroundImage: `url(${bgImg})` }}
                >
                  <div className="absolute left-1/2 top-1/2 h-[24px] w-[24px] -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-full">
                    <img
                      src={item.avatar || heroAvatar}
                      alt={item.name}
                      className="h-full w-full rounded-full object-cover object-center"
                    />
                  </div>
                </div>
              )}
              <div className="text-right text-[22px] leading-none font-black max-[980px]:text-[18px] md:text-[25px]">
                {item.point ?? '-'}
              </div>
            </button>
          </div>
        ))}
      </div>
    </aside>
  );
};

export default TopVoteList;
